import swal from "sweetalert";
import {
  login,
  prologin,
  prosignUp,
  runLogoutTimer,
  saveTokenInLocalStorage,
  signUp,
} from "../../services/AuthService";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";

export function signupAction(
  email,
  password,
  password_confirmation,
  phone_number,
  user_date,
  address,
  business_type,
  history
) {
  return (dispatch) => {
    signUp(
      email,
      password,
      password_confirmation,
      phone_number,
      user_date,
      address,
      business_type
    )
      .then((response) => {
        console.log(response);
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, response.data.expiry * 1000, history);
        swal(
          response.data.message,
          "Please Wait for Admin Approval",
          "success"
        );
        dispatch(confirmedSignupAction(response.data));
        history.push("/login");
      })
      .catch((errors) => {
        console.log(errors?.response?.data?.errors[0]);
        const errorMessage = errors?.response?.data?.errors[0];
        swal({
          icon: "error",
          title: errorMessage,
        });
        console.log(errorMessage);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}
export function ProsignupAction(
  user_date,
  business_type,
  address,
  phone_number,
  email,
  password,
  password_confirmation,
  history
) {
  return (dispatch) => {
    prosignUp(
      user_date,
      business_type,
      address,
      phone_number,
      email,
      password,
      password_confirmation,
      history
    )
      .then((response) => {
        console.log(response);
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, response.data.expiry * 1000, history);
        swal(
          response.data.message,
          "Please Wait for Admin Approval",
          "success"
        );
        dispatch(confirmedSignupAction(response.data));
        history.push("/Professional-login");
      })
      .catch((errors) => {
        console.log(errors?.response?.data?.errors[0]);
        const errorMessage = errors?.response?.data?.errors[0];
        swal({
          icon: "error",
          title: errorMessage,
        });
        console.log(errorMessage);
        dispatch(signupFailedAction(errorMessage));
      });
  };
}
export function logout(history) {
  localStorage.clear();
  history.push("/");
  return {
    type: LOGOUT_ACTION,
  };
}

export function loginAction(email, password, history) {
  return (dispatch) => {
    login(email, password)
      .then((response) => {
        console.log(response);
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, 10000 * 1000, history);
        dispatch(loginConfirmedAction(response.data));
        // swal("Good job!", response.data.message, "success");

        if (response.data.user?.payment === false) {
          swal("error", response.data.message, "error");
          history.push("/PackagePlan");
        } else {
          swal("Good job!", response.data.message, "success");
          history.push("/");
        }
      })
      .catch((error) => {
        console.log(error?.response?.data?.message);
        const errorMessage = error?.response?.data?.message;
        errorMessage
          ? swal({
              icon: "error",
              title: errorMessage,
            })
          : swal({
              icon: "error",
              title: "Connection Error",
            });

        dispatch(loginFailedAction(errorMessage));
      });
  };
}
export function loginProAction(email, password, history) {
  return (dispatch) => {
    prologin(email, password)
      .then((response) => {
        console.log(response);
        saveTokenInLocalStorage(response.data);
        runLogoutTimer(dispatch, 10000 * 1000, history);
        dispatch(loginConfirmedAction(response.data));
        // swal("Good job!", response.data.message, "success");

        if (response.data.user?.payment === false) {
          swal("error", response.data.message, "error");
          history.push("/");
        } else {
          swal("Good job!", response.data.message, "success");
          history.push("/");
        }
      })
      .catch((error) => {
        console.log(error?.response?.data?.message);
        const errorMessage = error?.response?.data?.message;
        errorMessage
          ? swal({
              icon: "error",
              title: errorMessage,
            })
          : swal({
              icon: "error",
              title: "Connection Error",
            });

        dispatch(loginFailedAction(errorMessage));
      });
  };
}
export function loginFailedAction(data) {
  return {
    type: LOGIN_FAILED_ACTION,
    payload: data,
  };
}

export function loginConfirmedAction(data) {
  return {
    type: LOGIN_CONFIRMED_ACTION,
    payload: data,
  };
}

export function confirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}
export function proconfirmedSignupAction(payload) {
  return {
    type: SIGNUP_CONFIRMED_ACTION,
    payload,
  };
}

export function signupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}
export function prosignupFailedAction(message) {
  return {
    type: SIGNUP_FAILED_ACTION,
    payload: message,
  };
}

export function loadingToggleAction(status) {
  return {
    type: LOADING_TOGGLE_ACTION,
    payload: status,
  };
}
